<template>
    <div class="images1" >
        <div class="message_card" style="">
            <div class="text-content" >
                <div>发送新消息，你可以根据UID推送到某个用户，也可以根据Topidld推送到某个主题，群发给用户.</div>
                <div>
                    接收消息的用户，必须先
                    <span class="message_btn" @click="showHouse()">扫描二维码</span>
                    关注你创建的主题，否则无法接收消息。
                </div>
            </div>
            <!--表单信息-->
            <div class = "my_from">
                <DxForm :form-data="formData">
                    <DxGroupItem :col-span="3">
                        <DxSimpleItem>
                            <DxLabel text="公众号" />
                            <template #default>
                                <div>
                                    <DxSelectBox @value-changed="changeWechatBox" :data-source="wechatSelect" display-expr="appName" value-expr="id"  value-change-event="keyup"></DxSelectBox>
                                </div>
                            </template>
                        </DxSimpleItem>


                        <DxSimpleItem data-field="UID">
                            <DxLabel text="接收消息的用户UID,多个UID用英文状态的,分隔" />
                        </DxSimpleItem>


                        <DxSimpleItem>
                            <DxLabel text="模板" />
                            <template #default>
                                <div>
                                    <DxSelectBox @value-changed="changeModeltBox" :data-source="modeSelect" display-expr="title" value-expr="template_id"  value-change-event="keyup"></DxSelectBox>
                                </div>
                            </template>
                        </DxSimpleItem>

                        <DxSimpleItem>
                            <DxLabel text="接收消息的某个标签,多个TID用英文状态的,分隔" />
                            <template #default>
                                <div>
                                    <DxSelectBox @value-changed="changeTagsBox" :data-source="positionOptions" display-expr="name" value-expr="id"  value-change-event="keyup"></DxSelectBox>
                                </div>
                            </template>
                        </DxSimpleItem>

                        <!--                <DxSimpleItem data-field="TagsID"/>-->
<!--                        <DxSimpleItem-->
<!--                                :editor-options="birthDateOptions"-->
<!--                                data-field="sendDate"-->
<!--                                editor-type="dxDateBox"-->
<!--                        >-->
<!--                            <DxLabel text="发送时间"></DxLabel>-->
<!--                        </DxSimpleItem>-->
                    </DxGroupItem>


                </DxForm>
                <!--发送内容，根据模板id查找map-->
                <div>
                    <div class="content-text">发送内容</div>
                    <DxForm :form-data="formData2" v-show="showContent"  :col-count="2">
                        <DxGroupItem v-for="(item,index) in itemMap" :key="index" >
                            <DxSimpleItem :data-field="item.itemValue">
                                <DxLabel :text="item.itemName" />
                            </DxSimpleItem>

                        </DxGroupItem>
                    </DxForm>
                </div>


                <DxButton @click="submitFrom" class="my_submit">发送</DxButton>

            </div>
        </div>


        <DxPopup
                :width="560"
                :height="640"
                :show-title="true"
                title="关注微信公众号"
                :drag-enabled="false"

                :visible="popupVisible" >


            <template #content="{ data }">
                <div class="popup-property-details" >
                    <DxSelectBox @value-changed="changeWechatImg" :data-source="wechatSelect" display-expr="appName" value-expr="id"  value-change-event="keyup"></DxSelectBox>
                    <div class="pop_img" v-show="showWechatImg" >
                        <img :src="imgUrl" class="img-style">
                    </div>

                </div>
            </template>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after"  :options="closeButtonOptions"><i class="dx-icon dx-icon-close"></i></DxToolbarItem>

        </DxPopup>
        </div>

</template>
<style>
    .message_card{
        font-size: 18px;
        padding-top: 40px;
        width: 100%;
    }
    .text-content{
        text-align: center;
    }
    .message_btn{
        color: #ff5722;
        border: 1px solid white;
        background: white;
        padding: 8px;
        border-radius: 10px;
    }
    .pop_img{
        padding: 20px 0;
    }
    .img-style{
        width: 610px;
        height: 300px;
    }
</style>
<script>

    import DxButton from 'devextreme-vue/button';
    import DxPopup from 'devextreme-vue/popup';
    import DxPopover from 'devextreme-vue/popover';
    import '../../../css/my_styles.css';
    import notify from "devextreme/ui/notify";


    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });

    export default {
        components: {
            DxButton, DxPopup, DxPopover,
        },
        created() {
        //wechatSelect
            this.$http.get_wxconfig(null).then(res =>{
                this.wechatSelect = res.data
            })
        },
        data() {
            return {
                imgUrl :'',
                currentHouse: new Object(),
                popupVisible: false,
                showWechatImg:false,
                closeButtonOptions: {
                    text: 'Close',
                    onClick: () => {
                        this.popupVisible = false;
                    },
                },
                position: {
                    offset: '0, 2',
                    at: 'bottom',
                    my: 'top',
                    collision: 'fit flip',
                },
                birthDateOptions: { width: '100%' },
                formData: {},
                formData2: {},
                positionOptions: [],
                loading: false,
                showContent:false,
                wechatSelect:[ ],
                modeSelect:[],
                itemMap:[]
            }

        },
        computed: {
            favoriteText() {
                return this.currentHouse.Favorite ? REMOVE_FROM_FAVORITES : ADD_TO_FAVORITES;
            },
        },
        methods: {
            currency(val) {
                return currencyFormatter.format(val);
            },
            closeHouse(){
                this.popupVisible = false;
            },
            showHouse() {
                this.popupVisible = true;

            },
            changeWechatBox(e){
                this.formData.wechatId = e.value
                //根据微信公众号获取所有的模板
                this.$http.get_template_all({"appId":e.value}).then(res =>{
                    this.modeSelect =res.data
                })
                //获取公众号用户标签
                this.$http.get_all_tags_pu({"appId":e.value}).then( res=>{
                    this.positionOptions = res.data
                })
            },
            submitFrom: async function(){
                this.loading = true;
                this.formData.sendConnet = this.formData2
                this.formData.uidStr = JSON.stringify([this.formData.UID])

                //提交信息
                this.$http.send_message_public(this.formData).then(res =>{
                    //console.log(res)
                    if(res.status == "success"){
                        notify(res.msg, "success", 2000);
                    }else{
                        notify(res.msg, "error", 2000);
                    }
                })

                //重置表单
                this.formData = []
                this.formData2 = []
                this.itemMap = []
                this.modeSelect = []
                this.wechatSelect = []
                this.positionOptions= []
                // this.formData.reset()
                // this.formData2.reset()

            },
            changeModeltBox(e) {
                this.itemMap = []
                this.formData.modeId = e.value
                const tmep = this.modeSelect.filter(item => item.template_id == e.value)

                for(let key in tmep[0].content){
                    let temp={
                        "itemValue":tmep[0].content[key],
                        "itemName" : key
                    }
                    this.itemMap.push(temp)
                }
                this.showContent = true
            },
            changeTagsBox(e){
                this.formData.tidStr=JSON.stringify([e.value])
            },
            changeWechatImg(e){
                this.imgUrl = ""
                this.$http.get_qrcode({"appId":e.value}).then(res =>{
                    if(res.code == 200){
                        this.imgUrl = "https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket="+res.data.ticket
                        this.showWechatImg=true
                    }else{
                        notify(res.msg, "error", 2000);
                    }

                })

            }

        },
    };
</script>

